import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Incidents } from 'src/app/domain/incidents.model';
import { IncidentFilterDto } from 'src/app/interfaces/Dtos/IncidentFilter.dto';
import { IncidentTypeDto } from 'src/app/interfaces/Dtos/incident-type.dto';
import { SiteDto } from 'src/app/interfaces/Dtos/site.dto';
import { IIncidentsResponse } from 'src/app/interfaces/Responses/IIncidentsResponse';

import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import Chart from 'chart.js/auto'
import { GridColumnsConfiguration, GridFilter } from '../../shared/grid/grid.component';
import { Route, Router } from '@angular/router';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { ModalPerformanceMonitoringComponent } from './modal-performance-monitoring/modal-performance-monitoring.component';
import { MatDialog } from '@angular/material/dialog';
import { GridServiceService } from 'src/app/services/shared/grid-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from 'src/app/services/security/login.service';

@Component({
  selector: 'neoris-performance-monitoring',
    templateUrl: './performance-monitoring.component.html',
  styleUrl: './performance-monitoring.component.css'
})
export class PerformanceMonitoringComponent {
  today = new Date();
  month = this.today.getUTCMonth();
  year = this.today.getUTCFullYear();
  day = this.today.getUTCDate()
  arrayIncidentsTypes:any[] = []
  modelTypes:any[] = []
  private onLanChange: Subscription
  lang:string = ''
  modelIncident: Incidents = {  eventTypes: [], data: [] }
  public chart:Chart
  public gFilter: GridFilter = undefined;
  arrayGirdMonitoringGridTemp: any[] = []
  arrayGirdMonitoringGrid: any[] = []
  filtersParam:any={}
  requestPerformanceMonitoring:any={}
  totalAcurracy:string=''
  totalRedLine:string=''
  totalPpe:string=''
  totalPersonalDetected:string=''
  totalUnsafe:string=''
  arrayAcurrancyChart:any[]=[]
  arrayDetectionsNumber:any[]=[]
  arrayLabelsChart:any[] = []
  arraySurcesDevices:any[]=[]
  private onDataUpdateMonitoring:Subscription
  private gridServiceServiceSubscription:Subscription
  private onIsAllSitesSubscription: Subscription
  Objmonitoring:any={}
  


  filters = new UntypedFormGroup({
    incidentType: new UntypedFormControl(''),
    device: new UntypedFormControl(''),
    start: new UntypedFormControl(new Date(this.year,  this.month , this.day -10)),
    end: new UntypedFormControl(new Date(this.year,  this.month , this.day))
  });

  @ViewChild('selIncidentType') selIncidentType: MatSelect;
  @ViewChild('selDevices') selDevices: MatSelect;


  constructor(private controltowerservice:ControltowerService,
    private translate: TranslateService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private routers:Router,
    private sharedService:PropertiesTowers,
    private dialog: MatDialog,
    private propertiesService:PropertiesTowers,
    private gridServiceService: GridServiceService,
    private _snackBar:MatSnackBar,
    private securityService: LoginService){
  }
  
  public gridColumnsConfigurationes: GridColumnsConfiguration = {
    IconValue: "",
    IconColumnName: "",
    hiddenColumnNames: ["siteid","eventtypeid","sourcedeviceid","accuracy","accuracyint", "ROW_ID", "performanceMonitoringId"],
    dateColumns: [
      { columnName: "date", showTime: false}
    ],
    cardColum: "site",
    cardValues: [
      
      { place: 0, nombre: 'date', isMainColumn: false },
      { place: 0, nombre: 'site', isMainColumn: false },
      { place: 0, nombre: 'detectionsnumber', isMainColumn: false },
      { place: 0, nombre: 'accuracy', isMainColumn: false },
      
      { place: 0, nombre: 'truepositives', isMainColumn: false },
      { place: 0, nombre: 'falsepositives', isMainColumn: false },
      { place: 0, nombre: 'isinvalid', isMainColumn: false },
      { place: 0, nombre: 'comment', isMainColumn: false },
      { place: 0, nombre: 'eventtype', isMainColumn: false }, 
    ],
    MultiIconColumns: [
      ],
    ActionColumn: {
      ColumnName: "",
      Actions: [
      ]
    }
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  async ngOnInit(): Promise<void> {
    
    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const guid = JSON.parse(localStorage.getItem('guidSession'))
    const response = await this.securityService.login(userName,guid).toPromise()

    let success

    this.onDataUpdateMonitoring = this.propertiesService.confirmUpdateFieldService$.subscribe((value) =>{
      console.log('valor de monitoring register update--->',value)
       if(value) {
        this.getPerformanceMonitoring()
        
       }
     })

     this.onIsAllSitesSubscription =  this.propertiesService.IsSelectAllSites$.subscribe((value) => {
      this.getFiltersAndIncidents()
      this.getPerformanceMonitoring() 
     
    })


     this.gridServiceServiceSubscription = this.gridServiceService.recieveSelectedRowsObservable.subscribe(selectedData => {
      console.log("SelectedGridData", selectedData)
      localStorage.setItem('SelectedGridDataMonitoring',JSON.stringify(selectedData))
      if(selectedData.length > 0){
        this.openDialog()
      }
      else{
        
        this.openSnackBar(this.translate.instant('TEXT_VALIDATION_RECORD_DEVICE_MANAGEMENT'),"Error")
      }
    })



   

    this.onLanChange =  this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.lang = s.lang != undefined ? s.lang : "en";
      success =   this.getFiltersAndIncidents()
      let successPerformance = this.getPerformanceMonitoring() 
      
      
    })



    if(this.lang == undefined || this.lang==''){
      console.log('entre en uno--------->')
      this.lang = "en"
    }


    

     await this.getFiltersAndIncidents()

     

     setTimeout(()=>{                           
      this.getPerformanceMonitoring() 
    }, 3000);
     
    
  }

  GoToIncidents(){
    this.routers.navigate(["/health-safety-control-tower-dashboard"]);

    this.getIncidendsByFilters()
    this.sharedService.setFiltersParam(this.filtersParam)
  }

  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }

  async getPerformanceMonitoring(){
    this.requestPerformanceMonitoring.deviceIncidentTypesId = []
    this.requestPerformanceMonitoring.sourcesDevices = []

    let checkedSites: SiteDto[] = [ { id: Number.parseInt(localStorage.getItem('site')), name: '' } ]
    let checkedIncidentsType: IncidentTypeDto[] = this.filters.get('incidentType').value
    let checkDevices : any[] = this.filters.get('device').value
    const startDate: Date = this.filters.get('start').value
    const endDate: Date = this.filters.get('end').value

    for(let i= 0;i<=checkedIncidentsType.length - 1;i++){
      if(checkedIncidentsType[i].id != undefined || checkedIncidentsType[i].id != null){
        this.requestPerformanceMonitoring.deviceIncidentTypesId.push(checkedIncidentsType[i].id)
      }
      
    }

    console.log('lo que voy a enviar en devices---->',checkDevices)
    for(let i= 0;i<=checkDevices.length - 1;i++){
      this.requestPerformanceMonitoring.sourcesDevices.push(checkDevices[i].sourcedevicE_ID)
    }


    console.log('sitio obtenido----->',localStorage.getItem('site'))
    console.log('sitios obtenidos 2',checkedSites)

    this.requestPerformanceMonitoring.local_code = this.lang == '' ? 'en' : this.lang
    this.requestPerformanceMonitoring.site = localStorage.getItem('site');
    this.requestPerformanceMonitoring.deviceStartDate = startDate
    this.requestPerformanceMonitoring.deviceEndDate = endDate
    this.requestPerformanceMonitoring.eventTypesId = [35, 36, 38, 39, 41]

    let success = await this.getPerformanceMonitoringService(this.requestPerformanceMonitoring)

    this.lineChart()

  }

  public cellClick(obj: any) {
    console.log("cellClick row monitoring----->", obj)
    console.log('elemento row monitoring------->:',obj)

    localStorage.setItem("rowMonitoring",JSON.stringify(obj))

    this.openDialog()


 
  }

  openDialog(): void {

    
    this.dialog.open(ModalPerformanceMonitoringComponent,
      {
        restoreFocus: false,
        width: '500px'
    });

   
  }

  checkSelection(){
    this.gridServiceService.requestSelectedRows()
  }




  toggleAllSelection(matSelect: MatSelect) {
    const isSelected: boolean = matSelect.options
      .filter((item: MatOption) => item.value === 0)
      .map((item: MatOption) => item.selected)
      [0];

    if (isSelected) {
      matSelect.options.forEach((item: MatOption) => item.select());
    } else {
      matSelect.options.forEach((item: MatOption) => item.deselect());
    } 
}


  
  private async getIncidendsByFilters() {
    console.log('llame al incident------>')
   
    console.log('este es el site',Number.parseInt(localStorage.getItem('site')))
    let checkedSites: SiteDto[] = [ { id: Number.parseInt(localStorage.getItem('site')), name: '' } ]
    let checkedIncidentsType: IncidentTypeDto[] = this.filters.get('incidentType').value
    let checkDevices : any[] = this.filters.get('device').value
    

    console.log('esto traigo en el site',checkedSites)
    console.log('esto traigo en el checkedIncidentsType',checkedIncidentsType)
    const startDate: Date = this.filters.get('start').value
    const endDate: Date = this.filters.get('end').value

    let search: boolean = true;

    if (checkedSites.length == 0) {
      search = false;
    }

    if (checkedIncidentsType.length == 0) {
      search = false;
    }

    if(checkDevices.length == 0){
      search = false;
    }

  
    console.log('antes de entrar al search----->',search)
    if (search == true) {
      console.log('entre al search----->')
      let filters: IncidentFilterDto = {
        eventTypesId: [ 35, 36, 38, 41],
        locale_code: this.lang == "" ? "en" : this.lang,
        sitesId: [],
        incidentsTypes: [],
        startDate: startDate, 
        endDate: endDate,       
        // statusesId: [1,2,3,4]
        statusesId: [1,2,3,4].map((statusId) => ({
          statusId: statusId,
          attributeTypeId: 43, 
          isAutoStatus: false
        })),
        visualSearchPrompts: [],
        responseLimits: 0
      }

      console.log('enviado-------',filters)
      checkedSites.forEach(site => {
        if(site.id !== undefined){
          filters.sitesId.push(site.id)
        }
      })
      checkedIncidentsType.forEach(incidentType => {
        if(incidentType.id !== undefined){
          filters.incidentsTypes.push(incidentType.id)
        }
      })


      this.filtersParam = filters
   

      let successIncidents = await this.getIncidents(filters)
    }else{
    
    }
  }

  private async getIncidentsTypes(): Promise<boolean> {


    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getIncidentsTypes(this.lang).subscribe(
        {

          next: (incidentype: any) => {
              this.arrayIncidentsTypes = incidentype
              console.log('obtener values select--->',this.arrayIncidentsTypes)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

 

  private async getPerformanceMonitoringService(request:any): Promise<boolean> {
    this.arrayAcurrancyChart = []
    this.arrayLabelsChart = []
    this.arrayDetectionsNumber = []

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getPerformanceMonitoring(request).subscribe(
        {
           next: (monitoring: any) => {
            this.Objmonitoring = monitoring


            var listMonitoring = monitoring.listPerformanceMonitoring;

            listMonitoring = listMonitoring.map((item, index) => ({
              ...item,
              ROW_ID: index + 1
            }));

            this.arrayGirdMonitoringGrid = listMonitoring
            let strtotalAcurracy = monitoring.totalKpi.accuracY_TOTAL * 100
            this.totalAcurracy = isNaN(strtotalAcurracy) ? "0" : parseInt(strtotalAcurracy.toString()).toString()
            
            let strTotalRedLine = monitoring.totalKpi.redlinE_TOTAL * 100
            this.totalRedLine = isNaN(strTotalRedLine) ? "0" : parseInt(strTotalRedLine.toString()).toString()

            let strTotalPpe = monitoring.totalKpi.ppE_TOTAL * 100
            this.totalPpe = isNaN(strTotalPpe) ? "0" : parseInt(strTotalPpe.toString()).toString()
            
            let strTotalPersonal = monitoring.totalKpi.personaldetecteD_TOTAL * 100
            this.totalPersonalDetected = isNaN(strTotalPersonal)  ? "0" : parseInt(strTotalPersonal.toString()).toString()

            let strTotalUnsafe = monitoring.totalKpi.unsafE_TOTAL * 100
            this.totalUnsafe = isNaN(strTotalUnsafe) ? "0" : parseInt(strTotalUnsafe.toString()).toString()

            monitoring.listPerformanceCharts.forEach(obj => {
              this.arrayAcurrancyChart.push(obj.accuracy)
              this.arrayDetectionsNumber.push(obj.detectionS_NUMBER)
              this.arrayLabelsChart.push(this.formatDate(obj.date))
            });
            console.log('obteneniendo valores de monitorin-------->',monitoring)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

 

  private async setDefaultFilters(){
   
    if (this.arrayIncidentsTypes.length > 0) {
      console.log('siiiiiiiiiiii----->')
      console.log('array devices----->',this.arrayIncidentsTypes)
      console.log('obtener values select2--->',this.selIncidentType.options)
      this.selIncidentType.options.forEach(f => {
        

        f.select()
       
      })

    }

    if(this.arraySurcesDevices.length > 0){
      this.selDevices.options.forEach(g => {
        g.select()
      })

    }
    await this.getIncidendsByFilters()
  }


  private async getFiltersAndIncidents(){
    const filtersInfoRetrieved: boolean = await this.getFilters()
    if (filtersInfoRetrieved) {
      setTimeout(()=>{                          
          this.setDefaultFilters()   
    }, 2000);
     
    }
    
  }


  async getFilters(){
    let successIncidentsTypes = await this.getIncidentsTypes()
    let succesSourcesDevices = await this.getSourcesDevices(this.lang == '' ? 'en' : this.lang,localStorage.getItem('site'))
  

    if(successIncidentsTypes){
      return true;
    }
    else{
      return false
    }
  }

  

  private async getIncidents(filters: IncidentFilterDto): Promise<boolean> {
    try {

   
      console.log('este es el filter----->',filters)
      const incident: IIncidentsResponse = await this.controltowerservice.getIncidents(filters).toPromise()  as IIncidentsResponse;;
      this.modelIncident = incident.result;
  
      console.log('este es el model incident------->', incident);
  
      this.modelIncident.eventTypes.forEach(this.updateEventTypeIcon);
  
      return true;
    } catch (error) {
      return false;
    }
  }
  
  private updateEventTypeIcon(eventType: any): void {
    switch (eventType.id) {
      case 35:
        if (eventType.urlIcon === '') {
          eventType.urlIcon = "/assets/images/controlTowers/ppe.png";
        }
        break;
      case 36:
        if (eventType.urlIcon === '') {
          eventType.urlIcon = "/assets/images/controlTowers/redzone.png";
        }
        break;
      case 38:
        if (eventType.urlIcon === '') {
          eventType.urlIcon = "/assets/images/controlTowers/work.png";
        }
        break;
      case 41:
        if (eventType.urlIcon === '') {
          eventType.urlIcon = "/assets/images/controlTowers/unsafe.png";
        }
        break;
    }
  }

 

  lineChart(){
    if (this,this.chart) {
      this.chart.destroy();
    }
    let labels =  this.arrayLabelsChart

    console.log('Esto es el array de chart--------->',this.arrayAcurrancyChart)

    


    


    Chart.defaults.layout.padding= 20;

    Chart.defaults.plugins.legend.display = true;
    Chart.defaults.plugins.legend.maxHeight = 70
    Chart.defaults.plugins.legend.labels.boxWidth = 40
    Chart.defaults.plugins.legend.labels.usePointStyle = false
    Chart.defaults.plugins.legend.align = "center"

    Chart.defaults.scales.linear.min = 0;

    

    const data = {
      yAxisID: 'A',
        labels: labels,
        datasets: []
      
    };

    this.chart = new Chart("chart",{
      type:'line',
      data,
      options: {
        responsive: true,
        maintainAspectRatio:false,
        scales: {
          A: {
            offset:true,
            suggestedMax: 105,
            type: 'linear',
            position: 'left',
            display:true,
            title:{
              display:true,
              text:'% ' +this.translate.instant('ACCURACY_INT'),
              font: {
                size: 20,
                
              },
              color:'rgba(239,200,42,1)'
                          },
            
            min: 0,
            max: 100,
          
            
           
            
            
            
          },
          B: {
            offset:true,
            type: 'linear',
            display: true,
            position: 'right',
            title:{
              display:true,
              text:this.translate.instant('DETECTIONS_NUMBER'),
              font: {
                size: 20,
                
              },
              color:'rgba(63,134,203,1)'
            },
            
            
          },
         
         
        },
        
        
        
        /*plugins: {
          legend: {
            display: true,
            position: 'right'
          }
        }*/
      }
      
    },
  )


  this.chart.data.datasets.push({
    yAxisID: 'A',
    label               : this.translate.instant('ACCURACY_INT'),
    backgroundColor     : 'rgba(239,200,42,1)',
    borderColor         : 'rgba(239,200,42,1)',
    data                : this.arrayAcurrancyChart,
    type                : 'line',
    
    
    
    
     
 
    
    
    
  });


  this.chart.data.datasets.push({
    yAxisID: 'B',
    label               : this.translate.instant('DETECTIONS_NUMBER'),
    backgroundColor     : 'rgba(63,134,203,1)',
    borderColor         : 'rgba(63,134,203,1)',
    data                : this.arrayDetectionsNumber,
    type                : 'bar',
    parsing: {
      yAxisKey: 'cogs'
    }
    
    
  });
    


   
    this.chart.update();

  }




  private async getSourcesDevices(lang:string,siteId:string): Promise<boolean> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getSourcesDevices(lang,siteId).subscribe(
        {
          next: (arraySources: any={}) => {
            
            console.log('obtenemos sources devices-------->',arraySources)
            this.arraySurcesDevices = arraySources.devices
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


 
 

}
